import type { Router } from "vue-router";

export async function clearReleaseMarker(router: Router, releaseId: string) {
  const route = router.currentRoute.value;
  if (route.query._verne_release !== releaseId) return;

  const query = { ...route.query };
  delete query._verne_release;
  // Keep Vue Router and browser history in sync without a full page reload.
  await router.replace({ path: route.path, query, hash: route.hash });
}
